// extracted by mini-css-extract-plugin
module.exports = {"container":"modal-window-container__2ve5p","data":"modal-window-data__3UFn3"};